<template>
  <bean-source-page
    :type="type"
    :columns="columns"
    :filter-columns="filterColumns"
    :form="form"
    title="操作日志"
    resource="operation_records"
    :actionButtons="['show']"
  />
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator';
import { filterColumnsExtend, columnsExtend } from '../admin_grapes/operation_records.js';

@Component
export default class OperationRecords extends Vue {
  @Prop(String) type;

  // form 新建表单初始化数据（default数据）
  form = {}

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - 页面类型 enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -页面RESTful api资源名
   */
  filterColumns() {
    const array = [
      'operatable_type_eq',
      'operatable_id_eq',
      'request_method_eq',
      'request_path_eq',
      'ip_address_eq'
    ].filter(Boolean)

    return filterColumnsExtend(array)
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - 页面类型 enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -页面RESTful api资源名
   */
  columns(h, { type }) {
    const array = [
      type === 'show' && 'id',
      'operator',
      'operatable_type',
      {
        prop: 'operatable_id',
        label: this.$t('operationRecord.operatableId')
      },
      'request_method',
      'request_path',
      'operation_description',
      type === 'show' && {
        key: 'request_params',
        renderCell(h, { props: { value } }) {
          return <pre>{ JSON.stringify(value, undefined, 2) }</pre>
        }
      },
      type === 'show' && {
        prop: 'previous_object',
        label: '操作前数据',
        renderCell(h, { props: { value } }) {
          return <pre>{ JSON.stringify(value, undefined, 2) }</pre>
        }
      },
      type === 'show' && {
        prop: 'current_object',
        label: '操作后数据',
        renderCell(h, { props: { value } }) {
          return <pre>{ JSON.stringify(value, undefined, 2) }</pre>
        }
      },
      'ip_address',
      'created_at'
    ].filter(Boolean);

    return columnsExtend(array)
  }
}

export const route = [
  {
    path: '/operation_records',
    name: 'operation_records.index',
    component: OperationRecords,
    props: {
      type: 'index',
    }
  },
  {
    path: '/operation_records/:id',
    name: 'operation_records.show',
    component: OperationRecords,
    props: {
      type: 'show',
    }
  }
]
</script>
